/* Ordinia: movimiento — «la casa que respira». Va con assets/ordinia-motion.css.
   Todo es progresivo: si algo no existe en el navegador (popover, View Transitions, WAAPI), la tienda funciona igual.
   Solo se anima transform/opacity; los bucles de puntero van en requestAnimationFrame. */
(function () {
  if (window.__ordMotion) return;
  window.__ordMotion = true;

  var reduce = false; // Decisión de la tienda: el movimiento se ve siempre, aunque el sistema pida reducirlo.
  var finePointer = matchMedia('(hover: hover) and (pointer: fine)').matches;
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  document.documentElement.classList.add('ord-js');

  /* ---------- Títulos de sección: entran al verse ---------- */
  var headIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('ord-head-in'); headIO.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -12% 0px' }) : null;
  function initHeads(root) {
    (root || document).querySelectorAll('.ord .ord-h2:not(.ord-head-in):not(.ord-head-done), .ord .ord-dst__title:not(.ord-head-in):not(.ord-head-done)').forEach(function (h) {
      // Lo que ya se ve al cargar no se esconde (evita un parpadeo); solo anima lo que entra después.
      if (!headIO || h.getBoundingClientRect().top < innerHeight) h.classList.add('ord-head-done');
      else headIO.observe(h);
    });
  }

  /* ---------- Barra de lectura ---------- */
  ready(function () {
    if (document.querySelector('.ord-progress')) return;
    var bar = document.createElement('div');
    bar.className = 'ord-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    if (!CSS.supports('animation-timeline: scroll()')) {
      var raf = 0;
      var paint = function () {
        raf = 0;
        var max = document.documentElement.scrollHeight - innerHeight;
        bar.style.transform = 'scaleX(' + (max > 0 ? clamp(scrollY / max, 0, 1) : 0) + ')';
      };
      addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(paint); }, { passive: true });
      paint();
    }
  });

  /* ---------- Portada: luz que sigue al dedo / ratón ---------- */
  function initGlow(root) {
    (root || document).querySelectorAll('.ord-vit:not([data-ord-glow])').forEach(function (hero) {
      hero.setAttribute('data-ord-glow', '');
      var raf = 0, x = 0, y = 0;
      function move(cx, cy) {
        var r = hero.getBoundingClientRect();
        x = clamp((cx - (r.left + r.width * 0.7)) * 0.35, -220, 220);
        y = clamp((cy - (r.top + r.height * 0.3)) * 0.35, -200, 200);
        if (!raf) raf = requestAnimationFrame(function () {
          raf = 0;
          hero.style.setProperty('--mx', x.toFixed(1));
          hero.style.setProperty('--my', y.toFixed(1));
        });
      }
      hero.addEventListener('pointermove', function (e) { move(e.clientX, e.clientY); }, { passive: true });
      hero.addEventListener('touchmove', function (e) { var t = e.touches[0]; if (t) move(t.clientX, t.clientY); }, { passive: true });
    });
  }

  /* ---------- Escaparate: inclinación 3D (solo ratón) ---------- */
  function initTilt(root) {
    if (!finePointer || reduce) return;
    (root || document).querySelectorAll('.ord-vit__tile:not([data-ord-tilt])').forEach(function (tile) {
      tile.setAttribute('data-ord-tilt', '');
      var img = tile.querySelector('.ord-vit__img');
      if (!img) return;
      var raf = 0, rx = 0, ry = 0;
      tile.addEventListener('pointermove', function (e) {
        var r = tile.getBoundingClientRect();
        ry = ((e.clientX - r.left) / r.width - 0.5) * 14;
        rx = -((e.clientY - r.top) / r.height - 0.5) * 12;
        tile.classList.add('is-tilting');
        if (!raf) raf = requestAnimationFrame(function () {
          raf = 0;
          img.style.setProperty('--rx', rx.toFixed(2) + 'deg');
          img.style.setProperty('--ry', ry.toFixed(2) + 'deg');
        });
      });
      tile.addEventListener('pointerleave', function () {
        tile.classList.remove('is-tilting');
        img.style.setProperty('--rx', '0deg');
        img.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---------- Botones imantados (solo ratón) ---------- */
  if (finePointer && !reduce) {
    document.addEventListener('pointermove', function (e) {
      var btn = e.target.closest && e.target.closest('.ord .ord-btn');
      if (!btn) return;
      var r = btn.getBoundingClientRect();
      btn.style.setProperty('--btn-x', clamp((e.clientX - (r.left + r.width / 2)) * 0.18, -8, 8).toFixed(1) + 'px');
      btn.style.setProperty('--btn-y', clamp((e.clientY - (r.top + r.height / 2)) * 0.3, -6, 6).toFixed(1) + 'px');
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      var btn = e.target.closest && e.target.closest('.ord .ord-btn');
      if (btn && !btn.contains(e.relatedTarget)) { btn.style.removeProperty('--btn-x'); btn.style.removeProperty('--btn-y'); }
    });
  }

  /* ---------- Cuenta atrás de la oferta: data-ord-countdown="2026-10-12T21:59:00Z" ---------- */
  var ORD_EN = /^en/i.test(document.documentElement.lang || '');
  var UNITS = [['d', ORD_EN ? 'days' : 'días'], ['h', 'h'], ['m', 'min'], ['s', 's']];
  function digitHTML() {
    var s = '<span class="ord-cd__dg"><span>';
    for (var i = 0; i < 10; i++) s += '<span>' + i + '</span>';
    return s + '</span></span>';
  }
  function buildCountdown(el) {
    var html = '<span class="ord-cd__live" aria-hidden="true"></span>';
    UNITS.forEach(function (u) {
      html += '<span class="ord-cd__u" data-u="' + u[0] + '" aria-hidden="true"><span class="ord-cd__n">' + digitHTML() + digitHTML() + '</span><span class="ord-cd__l">' + u[1] + '</span></span>';
    });
    el.innerHTML = html;
    el.setAttribute('role', 'timer');
    el.setAttribute('data-ord-built', '');
  }
  function setUnit(el, key, value) {
    var digits = el.querySelectorAll('[data-u="' + key + '"] .ord-cd__dg > span');
    var str = String(Math.min(value, 99)).padStart(2, '0');
    for (var i = 0; i < 2; i++) if (digits[i]) digits[i].style.transform = 'translateY(' + (-Number(str[i])) + 'em)';
  }
  var cdTimer = 0;
  function tickCountdowns() {
    var now = Date.now(), any = false;
    document.querySelectorAll('[data-ord-countdown]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-ord-countdown'));
      if (isNaN(end) || end <= now) { el.hidden = true; return; }
      if (!el.hasAttribute('data-ord-built')) buildCountdown(el);
      var left = Math.floor((end - now) / 1000);
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
      setUnit(el, 'd', d); setUnit(el, 'h', h); setUnit(el, 'm', m); setUnit(el, 's', s);
      // El texto para lectores de pantalla cambia una vez por minuto, no cada segundo.
      if (el.__ordMin !== m) {
        el.__ordMin = m;
        el.setAttribute('aria-label', ORD_EN
          ? 'Offer ends in ' + (d ? d + ' days, ' : '') + h + ' hours and ' + m + ' minutes'
          : 'La oferta termina en ' + (d ? d + ' días, ' : '') + h + ' horas y ' + m + ' minutos');
      }
      el.hidden = false;
      any = true;
    });
    clearTimeout(cdTimer);
    if (any) cdTimer = setTimeout(tickCountdowns, 1000 - (Date.now() % 1000) + 20);
  }

  /* ---------- Foto del producto que se transforma en la de la ficha (View Transitions entre páginas) ----------
     Sin el bloqueador de renderizado de Horizon (costaba ~0,5 s de LCP en la ficha): la foto pulsada recibe el nombre
     «ord-photo» y en la ficha lo lleva la primera foto de la galería (ordinia-motion.css). Solo puede haber una por página. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.ord a[href*="/products/"]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
    var scope = a.closest('.ord-vit__item, .ord-uso__tile, .ord-dst, .ord-card, li') || a;
    var img = a.querySelector('img') || scope.querySelector('img');
    if (!img || !('startViewTransition' in document)) return;
    document.querySelectorAll('[data-ord-photo]').forEach(function (el) { el.style.viewTransitionName = ''; el.removeAttribute('data-ord-photo'); });
    document.querySelectorAll('.product-media__image').forEach(function (el) { el.style.viewTransitionName = 'none'; });
    img.style.viewTransitionName = 'ord-photo';
    img.setAttribute('data-ord-photo', '');
  }, true);
  // Al volver atrás (bfcache) se quita el nombre para que no se repita en el siguiente clic.
  addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-ord-photo]').forEach(function (el) { el.style.viewTransitionName = ''; el.removeAttribute('data-ord-photo'); });
    document.querySelectorAll('.product-media__image').forEach(function (el) { el.style.viewTransitionName = ''; });
  });

  /* ---------- Carrito: la foto vuela, el icono salta y hay confeti al llegar al envío gratis ---------- */
  var layer = null;
  function getLayer() {
    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'ord-fly-layer';
      layer.setAttribute('aria-hidden', 'true');
      if ('popover' in HTMLElement.prototype) layer.setAttribute('popover', 'manual');
      else layer.style.zIndex = '2147483001';
      document.body.appendChild(layer);
    }
    // Volver a abrirlo lo pone encima del cajón del carrito (capa superior del navegador).
    if (layer.hasAttribute('popover')) {
      try { if (layer.matches(':popover-open')) layer.hidePopover(); layer.showPopover(); } catch (err) {}
    }
    return layer;
  }
  var pending = 0;
  // Si el cajón del carrito (u otro diálogo) se abre a mitad del vuelo, la capa vuelve a ponerse encima.
  if ('MutationObserver' in window) {
    new MutationObserver(function (list) {
      if (pending <= 0) return;
      for (var i = 0; i < list.length; i++) {
        if (list[i].target.tagName === 'DIALOG' && list[i].target.open) { getLayer(); break; }
      }
    }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
  }
  function releaseLayer() {
    if (--pending <= 0 && layer) { pending = 0; layer.innerHTML = ''; try { layer.hidePopover(); } catch (err) {} }
  }

  function visibleArea(el) {
    var r = el.getBoundingClientRect();
    var w = Math.min(r.right, innerWidth) - Math.max(r.left, 0);
    var h = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0);
    return w > 0 && h > 0 ? w * h : 0;
  }
  // Parte de un rectángulo que queda dentro de la pantalla (el vuelo sale de lo que el cliente está viendo).
  function visibleRect(r) {
    var left = Math.max(r.left, 0), top = Math.max(r.top, 0);
    var right = Math.min(r.right, innerWidth), bottom = Math.min(r.bottom, innerHeight);
    if (right <= left || bottom <= top) return r;
    return { left: left, top: top, width: right - left, height: bottom - top };
  }
  function biggestVisibleImg(scope) {
    var best = null, area = 0;
    scope.querySelectorAll('img').forEach(function (img) {
      var a = visibleArea(img), r = img.getBoundingClientRect();
      if (a > area && img.naturalWidth && a >= r.width * r.height * 0.35) { area = a; best = img; }
    });
    return best;
  }

  var flySource = null;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var btn = form.querySelector('button[name="add"], button[type="submit"]');
    var section = form.closest('.shopify-section') || document;
    var img = biggestVisibleImg(section) || biggestVisibleImg(document.querySelector('main') || document);
    var src = img || document.querySelector('main [data-view-transition-type] img, main img');
    flySource = {
      src: src ? (src.currentSrc || src.src) : '',
      rect: visibleRect((img || btn || form).getBoundingClientRect()),
      time: Date.now()
    };
    // Respuesta inmediata: la foto sale ya hacia el carrito; el salto del icono espera a la confirmación (cart:update).
    fly(flySource);
  }, true);

  function cartTarget() {
    var icon = document.querySelector('.header-actions__cart-icon');
    if (icon && visibleArea(icon) > 0) return icon.getBoundingClientRect();
    return { left: innerWidth - 44, top: 12, width: 28, height: 28 };
  }

  function bumpIcon() {
    var icon = document.querySelector('.header-actions__cart-icon');
    if (!icon) return;
    icon.classList.remove('ord-bump');
    void icon.offsetWidth;
    icon.classList.add('ord-bump');
    setTimeout(function () { icon.classList.remove('ord-bump'); }, 800);
  }

  function fly(source) {
    if (!source || !source.src || reduce || !Element.prototype.animate) return;
    var to = cartTarget();
    var from = source.rect;
    var size = clamp(Math.min(from.width, from.height), 64, 260);
    var x0 = from.left + from.width / 2, y0 = from.top + from.height / 2;
    var x1 = to.left + to.width / 2, y1 = to.top + to.height / 2;
    var s1 = clamp(Math.max(to.width, to.height) / size, 0.12, 0.6);
    var img = new Image();
    img.src = source.src;
    img.alt = '';
    img.className = 'ord-fly';
    img.style.cssText = 'left:' + (x0 - size / 2) + 'px;top:' + (y0 - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px;';
    pending++;
    getLayer().appendChild(img);
    var dx = x1 - x0, dy = y1 - y0;
    var lift = Math.min(140, Math.max(0, Math.min(y0, y1) - 40)); // el punto más alto del arco queda dentro de la pantalla
    var anim = img.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + dx * 0.35 + 'px,' + (dy * 0.35 - lift) + 'px) scale(' + (0.55 + s1 / 2) + ') rotate(-10deg)', opacity: 1, offset: 0.45 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + s1 + ') rotate(0deg)', opacity: 0.2 }
    ], { duration: 760, easing: 'cubic-bezier(.55,0,.25,1)', fill: 'forwards' });
    anim.onfinish = function () {
      img.remove();
      if (navigator.vibrate) { try { navigator.vibrate(12); } catch (err) {} }
      releaseLayer();
    };
  }

  var COLORS = ['#c1663d', '#e08a5f', '#8a9a7e', '#f2c9a8', '#2b241d', '#f6efe4'];
  function confetti(rect) {
    if (reduce || !Element.prototype.animate) return;
    var l = getLayer();
    var cx = rect ? rect.left + rect.width / 2 : innerWidth / 2;
    var cy = rect ? rect.top + rect.height / 2 : innerHeight / 3;
    var n = 46, done = 0;
    pending++;
    for (var i = 0; i < n; i++) {
      var p = document.createElement('i');
      p.className = 'ord-confetti';
      p.style.cssText = 'left:' + cx + 'px;top:' + cy + 'px;background:' + COLORS[i % COLORS.length] + ';' + (i % 3 === 0 ? 'border-radius:50%;width:8px;height:8px;' : '');
      l.appendChild(p);
      var ang = (Math.random() * 1.2 - 0.6) * Math.PI - Math.PI / 2;
      var v = 140 + Math.random() * 220;
      var dx = Math.cos(ang) * v, dy = Math.sin(ang) * v;
      var rot = (Math.random() * 2 - 1) * 720;
      p.animate([
        { transform: 'translate(-50%,-50%) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + rot / 2 + 'deg)', opacity: 1, offset: 0.4 },
        { transform: 'translate(' + dx * 1.3 + 'px,' + (dy + 320) + 'px) rotate(' + rot + 'deg)', opacity: 0 }
      ], { duration: 1300 + Math.random() * 700, easing: 'cubic-bezier(.2,.7,.4,1)', fill: 'forwards' }).onfinish = (function (el) {
        return function () { el.remove(); if (++done === n) releaseLayer(); };
      })(p);
    }
  }

  var shipDone = null;
  ready(function () { shipDone = !!document.querySelector('.ord-ship--done'); });
  document.addEventListener('cart:update', function () {
    var source = flySource && Date.now() - flySource.time < 10000 ? flySource : null;
    flySource = null;
    // El cajón tarda un instante en abrirse y pintar la línea nueva.
    setTimeout(function () {
      bumpIcon();
      var bar = document.querySelector('cart-drawer-component .ord-ship--done .ord-ship__bar, .ord-ship--done .ord-ship__bar');
      var now = !!document.querySelector('.ord-ship--done');
      if (now && shipDone === false) setTimeout(function () { confetti(bar && visibleArea(bar) ? bar.getBoundingClientRect() : null); }, source ? 250 : 0);
      shipDone = now;
    }, 380);
  });

  /* ---------- Chat Ordinia IA (Microsoft Clarity): ventana flotante en el centro ---------- */
  // El chat vive en un shadow root abierto (#ads-agent-host) que el CSS del tema no alcanza: se le inyecta un <style>.
  // Solo la ventana flotante (en escritorio); el modo «Expandir» (barra lateral, border-radius 0) se queda a la derecha.
  // Si Clarity cambia sus clases, el selector deja de coincidir y el chat vuelve a su sitio de siempre: no se rompe nada.
  function centerAgent() {
    var host = document.getElementById('ads-agent-host');
    if (!host || !host.shadowRoot) return false;
    if (host.shadowRoot.getElementById('ord-agent-centro')) return true;
    var s = document.createElement('style');
    s.id = 'ord-agent-centro';
    s.textContent = '@media (min-width: 750px){div.fixed.w-120.will-change-transform:not([style*="border-radius: 0px"]){left:50% !important;right:auto !important;top:50% !important;translate:-50% -50% !important;margin-right:0 !important}}';
    host.shadowRoot.appendChild(s);
    return true;
  }
  ready(function () {
    if (centerAgent() || !('MutationObserver' in window)) return;
    var agentMO = new MutationObserver(function () {
      if (!document.getElementById('ads-agent-host')) return;
      agentMO.disconnect();
      // El shadow root puede llegar un instante después que el host.
      (function retry(n) { if (!centerAgent() && n < 20) setTimeout(function () { retry(n + 1); }, 250); })(0);
    });
    agentMO.observe(document.body, { childList: true });
    setTimeout(function () { agentMO.disconnect(); }, 60000);
  });

  /* ---------- Arranque ---------- */
  function init(root) { initHeads(root); initGlow(root); initTilt(root); tickCountdowns(); }
  ready(function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
